/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Question/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Question({
  children,
  viewPath = "/DesignSystem/Question",
  fontSize = 20,
  marginBottom = 10,
  marginTop = 15,
  marginLeft = 0,
  marginRight = 0,
  text = "What is the dental plan the patient is using?"
  
}) {
  return (<React.Fragment
>
<span
  data-testid="Question.Question:1"
  data-view-path={viewPath}
 style={{'--fs-1-Z1iwBUS': typeof fontSize === 'number' ? `${fontSize}px` : fontSize,'--mb-2-Z1iwBUS': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--mt-3-Z1iwBUS': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--ml-4-Z1iwBUS': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1iwBUS': typeof marginRight === 'number' ? `${marginRight}px` : marginRight}}
 className={`views-text ${styles.Question1}`}
>
{text}
</span>
{children}
</React.Fragment>)
}